import { SxProps } from '@mui/material';
import { CircularProgress, InputAdornment } from '@mui/material';
import React from 'react';

export const LoadingAdornment = ({sx}: {sx?: SxProps}) => (
  <InputAdornment sx={sx} disablePointerEvents position="end">
    <CircularProgress size={24} />
  </InputAdornment>
);
